import React, { useState, useEffect, useRef } from 'react';
import LayerControl from '../LayerControlPage/LayerControl';
import requestTool from '../../tools/requestTool';
import { MultiSelect } from 'primereact/multiselect'
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Messages } from 'primereact/messages';
import { useMountEffect } from 'primereact/hooks';
import { Panel } from 'primereact/panel';
export const TreeAuthorization = (props) => {

    const [roles, setRoles] = useState(null);
    const [users, setUsers] = useState(null);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedLayers, setSelectedLayers] = useState([]);
    const [permisions, setPermisions] = useState({ isShow: false, isEdit: false });
    const [authorization, setAuthorization] = useState(null);
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const msgs = useRef(null);

    useEffect(() => {
        getRoles();
        getUsers();

    }, {});


    useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show({ id: '1', sticky: true, severity: 'info', summary: 'Info', detail: 'Yetkileri görmek için ilgili  bir rolü veya kullanıcıyı seçiniz', closable: false });
        }
    });


    const getRoles = () => {

        requestTool.getRequest(props.crudApiUrl + "/api/UserRole/GetRoles").then(response => {

            if (!response) {

            }
            if (!response.success) {
                console.log("veri bulunamadı");
            }
            setRoles(response.data);

        }).catch(e => { console.log(e); });
    }
    const getUsers = () => {
        requestTool.getRequest(props.crudApiUrl + "/api/UserRole/GetUsers").then(response => {

            if (!response) {

            }
            if (!response.success) {
                console.log("veri bulunamadı");
            }
            setUsers(response.data);

        }).catch(e => { console.log(e); });
    }
    const getAllAuthorization = (data) => {

        setAuthorization([]);

        requestTool.postRequest(props.dynamicApiUrl + "/TreeAuthorization/GetAllAuthorization",

            {
                roleIds: data.roles ? data.roles : [],
                userIds: data.users ? data.users : [],
                layerIds: null,
                isEdit: permisions.isEdit,
                isShow: permisions.isShow
            }
        ).then(response => {

            if (!response) {

            }
            if (!response.success) {
                console.log("veri bulunamadı");
            }

            setAuthorization(response.data ? response.data : []);

        }).catch(e => { console.log(e); });



    }
    const addUpdateAuthorization = () => {

        if (selectedLayers.length < 1) {
            //return toast.current.show({ severity: 'error', summary: 'Hata !', detail: "Katman seçiniz" });
        }
        if (selectedRoles.length < 1 && selectedUsers.length < 1) {
            return toast.current.show({ severity: 'error', summary: 'Hata !', detail: "Rol veya kullanıcı seçiniz" });

        }
        setLoading(true);
        requestTool.postRequest(props.dynamicApiUrl + "/TreeAuthorization/AddUpdateAuthorization",
            {
                roleIds: selectedRoles.map(x => parseInt(x.id)),
                userIds: selectedUsers.map(x => parseInt(x.id)),
                layerIds: selectedLayers.map(x => parseInt(x)),
                isEdit: permisions.isEdit,
                isShow: permisions.isShow
            }
        ).then(response => {


            if (!response.success) {
                toast.current.show({ severity: 'danger', summary: 'Hata!', detail: response.mesage });
            }
            setLoading(false);

            getAllAuthorization({ roles: selectedRoles.map(x => parseInt(x.id)), users: selectedUsers.map(x => parseInt(x.id)) });

            toast.current.show({ severity: 'success', summary: 'info', detail: response.message });

        }).catch(e => { console.log(e); });
    }
   
    return (
        <>    <Toast ref={toast} />

            <center><h1>Ağaç yapısı yetkilendirme</h1></center>

            <div class="grid" >
                <div class="col col-6" >

                    <Panel header="Ağaç Yapısı" style={{ overflowY: 'auto', maxHeight: '90vh' }}>
                        <div style={{ overflowY: "auto" }}>
                            <div class="col col-6" >
                                <Messages ref={msgs} />
                            </div>
                            {authorization && authorization.length > 0 ? <LayerControl

                                selectedNodes={authorization}
                                isOnlyTreeAndCheckBox={true}
                                onSelectedNode={(node) => {
                                    setSelectedLayers(node);
                                }}
                                onCheckedNode={(node) => {
                                    setSelectedLayers(node.map(x => parseInt(x.value)));

                                }}

                            /> :
                                <LayerControl


                                    isOnlyTreeAndCheckBox={true}
                                    onSelectedNode={(node) => {
                                        setSelectedLayers(node);
                                    }}
                                    onCheckedNode={(node) => {
                                        setSelectedLayers(node.map(x => parseInt(x.value)));

                                    }}

                                />}



                        </div>
                    </Panel>


                </div>
                <div class="col-6">

                    <Panel header="Roller ve Kullanıcılar">
                        <div class="field grid">
                            <div class="col">
                                <MultiSelect className="w-full" maxSelectedLabels={10} filter value={selectedRoles} onChange={(e) => {

                                    setSelectedRoles(e.value);
                                    getAllAuthorization({ roles: e.value.map(x => parseInt(x.id)) });


                                }} options={roles} optionLabel="name"
                                    placeholder="Rol Seçiniz" />
                            </div>
                        </div>
                        <div class="field grid">
                            <div class="col">
                                <label>Kullanıcılar</label>
                                <br />
                                <br />
                                <MultiSelect className="w-full" maxSelectedLabels={10} filter value={selectedUsers} onChange={(e) => {

                                    setSelectedUsers(e.value);
                                    getAllAuthorization({ users: e.value.map(x => parseInt(x.id)) });

                                }} options={users} optionLabel="name"
                                    placeholder="Kullanıcı Seçiniz" />
                            </div>
                        </div>
                        <div className="card flex flex-wrap  gap-3">
                            <div className="flex align-items-center">
                                <Checkbox disabled={permisions.isEdit} checked={permisions.isShow} inputId="ingredient1" name="read" onChange={(e) => {

                                    setPermisions({ isEdit: permisions.isEdit, isShow: permisions.isEdit ? true : e.checked });
                                }} />
                                <label htmlFor="ingredient1" className="ml-2">Okuma</label>
                            </div>
                            <div className="flex align-items-center">
                                <Checkbox checked={permisions.isEdit} inputId="ingredient2" name="edit" onChange={(e) => {

                                    setPermisions({ isShow: e.checked ? true : permisions.isShow, isEdit: e.checked });
                                }} />
                                <label htmlFor="ingredient2" className="ml-2">Düzenleme</label>
                            </div>


                        </div>
                        <br />


                        <div className="card flex flex-wrap gap-3">
                            <Button loading={loading} onClick={addUpdateAuthorization} label="Kaydet" severity="success" />
                        
                        </div>

                    </Panel>
                </div>




            </div >


        </>


    );

}

export default TreeAuthorization;